import React, { useEffect } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import store from '../store/store'
import { useDispatch, useSelector } from 'react-redux'
import { routes } from '../utils/routes'
import { logout } from '../store/loginSlice'
import AccessDenied from '../pages/authentication/accessDenied'

const Authenticate = (props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const auth = store?.getState()?.login?.token
  const { userDetails } = useSelector((state) => state.login)
  const twoFaEnabled = userDetails?.two_factor_authentication
  const twoFaStatus = userDetails?.two_factor_authentication_status
  const path = location?.pathname

  useEffect(() => {
    if (!auth) {
      // return navigate(routes.login.path, { replace: true })
    } else {
      if (path == routes.twofa.path) {
        if (twoFaEnabled && twoFaStatus) navigate(routes.adminDashboard.path)
      } else if (twoFaEnabled && !twoFaStatus) navigate(routes.twofa.path)
    }
  }, [location])

  return props.children
  // return <AccessDenied />
}

export default Authenticate
